// extracted by mini-css-extract-plugin
module.exports = {"container":"h4MLN","text":"_34klu"};